import { useSelector } from 'react-redux';
import FormField from '../../../ui/formField';

const LifeInsuranceSection = (props) => {
  const exitingInsuranceData = useSelector(
    (state) => state.exitingInsuranceData
  );

  const removeCommaSeparator = (value) => {
    return value.replace(/\,/g, '');
  };

  const { loading, error, eiData } = exitingInsuranceData;
  const onFieldChangeHandler = (e) => {
    props.setLifeInsuranceData((prevState) => ({
      ...prevState,

      [e.target.name]:
        e.target.dataset.validationtype === 'financialValue'
          ? removeCommaSeparator(e.target.value)
          : e.target.value,
    }));
  };
  return (
    <div className="flex">
      {eiData?.data?.lifeInsuranceFields.map((item, index) => {
        return (
          <FormField
            key={index}
            label={item.label}
            id={item.id}
            value={item.value}
            type={item.type}
            name={item.name}
            placeholder={item.placeholder}
            layoutType={item.layoutType}
            onChangeHandler={onFieldChangeHandler}
            selectOptions={item.selectOptions}
            dropdownType={item.dropdownType}
            validationType={item.validationType}
          />
        );
      })}
    </div>
  );
};

export default LifeInsuranceSection;
